import React from 'react';
import { Row, Span } from 'components';
import { FONTS, SPACING } from 'utils';

interface LegendasProps {
	naoIniciada: string,
	emAndamento: string,
	concluida: string,
	encerrado: string
}
const Legendas: React.FC<LegendasProps> = ({ naoIniciada, emAndamento, concluida, encerrado }) => {
	return (
		<>
			<Row justifyContent="flex-end" marginBottom={SPACING.spacing20} marginRight={SPACING.spacing20} gap={SPACING.spacing20}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<svg height="20" width="20" style={{ fill: '#DB5461' }}>
						<circle cx="10" cy="10" r="10" />
					</svg>
					<Span
						text={naoIniciada}
						style={{ fontWeight: FONTS.bold, fontFamily: 'Arial, Helvetica, sans-serif' }}
						marginLeft={SPACING.spacing5}
					/>

				</div>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<svg height="20" width="20" style={{ fill: '#FFEB3B' }}>
						<circle cx="10" cy="10" r="10" />
					</svg>
					<Span
						text={emAndamento}
						style={{ fontWeight: FONTS.bold, fontFamily: 'Arial, Helvetica, sans-serif' }}
						marginLeft={SPACING.spacing5}
					/>
				</div>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<svg height="20" width="20" style={{ fill: '#81C784' }}>
						<circle cx="10" cy="10" r="10" />
					</svg>
					<Span
						text={concluida}
						style={{ fontWeight: FONTS.bold, fontFamily: 'Arial, Helvetica, sans-serif' }}
						marginLeft={SPACING.spacing5}
					/>
				</div>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<svg height="20" width="20" style={{ fill: '#cccccc' }}>
						<circle cx="10" cy="10" r="10" />
					</svg>
					<Span
						text={encerrado}
						style={{ fontWeight: FONTS.bold, fontFamily: 'Arial, Helvetica, sans-serif' }}
						marginLeft={SPACING.spacing5}
					/>
				</div>
			</Row>
		</>
	)
}
export default Legendas;